import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { useTranslation } from 'shared/i18n'
import { useSnackbar } from 'shared/ui/Snackbar'

// アクセスできないパス(存在しない・権限が無い)に来たとき、
// トーストを出して映像一覧(/)へ戻すための共通フック。
export function useNotFoundRedirect (): () => void {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  return useCallback(() => {
    enqueueSnackbar(t('shared.useNotFoundRedirect.enqueueSnackbar'), { variant: 'error' })
    navigate('/', { replace: true })
  }, [navigate, enqueueSnackbar, t])
}
